import { Type } from "@sinclair/typebox";
import { Recipient } from "./recipient";
export const StatusType = Type.Union([Type.Literal("delivered"), Type.Literal("read")]);
export const BaseMessageStatus = Type.Object({
    /**
     * The Deskpro unique ID of the message.
     */
    message_id: Type.String(),
    /**
     * The Deskpro external ID of the message, will come from UI or App.
     */
    external_id: Type.String(),
    /**
     * The Deskpro unique ID of the conversation.
     */
    conversation_id: Type.String(),
    /**
     * The date and time of when the message status was created.
     */
    created_at: Type.String(),
    /**
     * The recipient of the message status.
     */
    recipients: Type.Array(Recipient),
}, {
    title: "BaseMessageStatus",
});
export const MessageStatusDelivered = Type.Composite([
    BaseMessageStatus,
    Type.Object({
        type: Type.Literal("delivered"),
    }, {
        title: "MessageStatusDelivered",
    }),
]);
export const MessageStatusRead = Type.Composite([
    BaseMessageStatus,
    Type.Object({
        type: Type.Literal("read"),
    }, {
        title: "MessageStatusRead",
    }),
]);
export const MessageStatus = Type.Union([MessageStatusDelivered, MessageStatusRead]);
